import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';

import { FAIcon } from './fa-icon';

export const ArrowUpRightFromSquare = ({ width }: { width?: string }) => (
  <FAIcon icon={faArrowUpRightFromSquare} width={width} />
);
